"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var table_options_1 = __importDefault(require("./table-options"));
var react_1 = __importStar(require("react"));
var translations_context_1 = __importDefault(require("../../context/translations/translations.context"));
var table_context_1 = __importDefault(require("./table-context"));
var sortable_table_styled_component_1 = require("../sortable-table/sortable-table.styled.component");
var header_cell_component_1 = __importStar(require("./header-cell.component"));
var cell_component_1 = __importDefault(require("./cell.component"));
function RowInternals(props) {
    var render = props.render, row = props.row, options = props.options;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        render(row),
        options && options.length > 0 && react_1.default.createElement(table_options_1.default, { id: row.id, item: row, options: options })));
}
function TableWrapper(props) {
    var getTranslation = react_1.useContext(translations_context_1.default).getTranslation;
    var headers = props.headers, rows = props.rows, noParentRow = props.noParentRow, sortDirection = props.sortDirection, currentSortColumn = props.currentSortColumn, setCurrentSortColumn = props.setCurrentSortColumn, striped = props.striped, noSpacing = props.noSpacing, testID = props.testID, options = props.options, customRowComponent = props.customRowComponent, displayRowIndex = props.displayRowIndex;
    var hasOptions = options && options.length > 0;
    return (react_1.default.createElement(table_context_1.default.Provider, { value: props },
        react_1.default.createElement(sortable_table_styled_component_1.Table, { "data-test-id": testID },
            headers.length > 0 && (react_1.default.createElement(sortable_table_styled_component_1.Header, null,
                react_1.default.createElement("tr", null,
                    headers.map(function (header) { return (react_1.default.createElement(header_cell_component_1.default, { key: header.id, tableHeader: header, onSortBy: setCurrentSortColumn, sortColumn: currentSortColumn, currentSortDirection: sortDirection, isEmpty: header.isEmpty })); }),
                    hasOptions && react_1.default.createElement(header_cell_component_1.InternalHeaderCell, { isSortable: false })),
                !noSpacing && react_1.default.createElement(sortable_table_styled_component_1.RowSpacing, null))),
            react_1.default.createElement("tbody", null,
                customRowComponent && !displayRowIndex && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(sortable_table_styled_component_1.Row, null,
                        react_1.default.createElement(cell_component_1.default, { colSpan: headers.length + 1 }, customRowComponent)))),
                (rows && rows.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null, rows.map(function (row, index) { return (react_1.default.createElement(react_1.default.Fragment, { key: row.id },
                    !noParentRow && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(sortable_table_styled_component_1.Row, { className: "table-row", key: row.id, striped: Boolean(striped && index % 2 === 1), noSpaceAfter: displayRowIndex === index },
                            react_1.default.createElement(RowInternals, __assign({}, props, { row: row }))),
                        displayRowIndex === index && (react_1.default.createElement(sortable_table_styled_component_1.Row, null,
                            react_1.default.createElement(cell_component_1.default, { colSpan: headers.length + 1 }, customRowComponent),
                            ' ')))),
                    noParentRow && (react_1.default.createElement(react_1.default.Fragment, { key: row.id },
                        react_1.default.createElement(RowInternals, __assign({}, props, { row: row })))))); })))) ||
                    (!customRowComponent && (react_1.default.createElement(sortable_table_styled_component_1.Row, null,
                        react_1.default.createElement(cell_component_1.default, { colSpan: headers.length },
                            react_1.default.createElement(sortable_table_styled_component_1.NoRows, null, getTranslation('GLOBAL:NO_DATA'))))))))));
}
TableWrapper.displayName = 'TableWrapper';
exports.default = TableWrapper;
//# sourceMappingURL=table.component.js.map